import { TIME_TAKEN_TASK_DEFAULT, TIME_TAKEN_STAFF_DEFAULT, VALUE_OF_TIME_STAFF_DEFAULT, VALUE_OF_TIME_HOURS_ALT_DEFAULT, SCENARIO_DEFAULT } from "@components/data/calculations";
import React, { createContext, useState, useEffect } from "react";
import { isDebugMode, trackFormInput, trackVirtualPageview } from "@utils/trackingUtils";
import { getWorkflowStepName } from "@utils/helper";


const defaultState = {
  currentStep: 0,
  showContentModal: false,

  physician_hours_xiaflex: TIME_TAKEN_STAFF_DEFAULT.physician_xiaflex,
  nurse_hours_xiaflex: TIME_TAKEN_STAFF_DEFAULT.nurse_xiaflex,
  other_hours_xiaflex: TIME_TAKEN_STAFF_DEFAULT.other_xiaflex,
  physician_hours_fasciectomy: TIME_TAKEN_STAFF_DEFAULT.physician_fasciectomy,
  nurse_hours_fasciectomy: TIME_TAKEN_STAFF_DEFAULT.nurse_fasciectomy,
  other_hours_fasciectomy: TIME_TAKEN_STAFF_DEFAULT.other_fasciectomy,

  patient_consultation_xiaflex: TIME_TAKEN_TASK_DEFAULT.patient_consultation_xiaflex,
  procedure_planning_xiaflex: TIME_TAKEN_TASK_DEFAULT.procedure_planning_xiaflex,
  patient_check_in_xiaflex: TIME_TAKEN_TASK_DEFAULT.patient_check_in_xiaflex,
  room_and_materials_preparation_xiaflex: TIME_TAKEN_TASK_DEFAULT.room_and_materials_preparation_xiaflex,
  procedure_xiaflex: TIME_TAKEN_TASK_DEFAULT.procedure_xiaflex,
  recovery_and_discharge_xiaflex: TIME_TAKEN_TASK_DEFAULT.recovery_and_discharge_xiaflex,
  follow_up_visits_xiaflex: TIME_TAKEN_TASK_DEFAULT.follow_up_visits_xiaflex,
  physical_therapy_xiaflex: TIME_TAKEN_TASK_DEFAULT.physical_therapy_xiaflex,

  patient_consultation_fasciectomy: TIME_TAKEN_TASK_DEFAULT.patient_consultation_fasciectomy,
  procedure_planning_fasciectomy: TIME_TAKEN_TASK_DEFAULT.procedure_planning_fasciectomy,
  patient_check_in_fasciectomy: TIME_TAKEN_TASK_DEFAULT.patient_check_in_fasciectomy,
  room_and_materials_preparation_fasciectomy: TIME_TAKEN_TASK_DEFAULT.room_and_materials_preparation_fasciectomy,
  procedure_fasciectomy: TIME_TAKEN_TASK_DEFAULT.procedure_fasciectomy,
  recovery_and_discharge_fasciectomy: TIME_TAKEN_TASK_DEFAULT.recovery_and_discharge_fasciectomy,
  follow_up_visits_fasciectomy: TIME_TAKEN_TASK_DEFAULT.follow_up_visits_fasciectomy,
  physical_therapy_fasciectomy: TIME_TAKEN_TASK_DEFAULT.physical_therapy_fasciectomy,

  physician_value: VALUE_OF_TIME_STAFF_DEFAULT.physician,
  nurse_value: VALUE_OF_TIME_STAFF_DEFAULT.nurse,
  other_value: VALUE_OF_TIME_STAFF_DEFAULT.other,

  physician_alt_hours: VALUE_OF_TIME_HOURS_ALT_DEFAULT.physician,
  nurse_alt_hours: VALUE_OF_TIME_HOURS_ALT_DEFAULT.nurse,
  other_alt_hours: VALUE_OF_TIME_HOURS_ALT_DEFAULT.other,

  num_dc_patients: SCENARIO_DEFAULT.num_dc_patients,

  scenerio_baseline_xiaflex: SCENARIO_DEFAULT.baseline_xiaflex,
  scenerio_new_xiaflex: SCENARIO_DEFAULT.new_xiaflex,
  
  scenerio_baseline_hours_physician: 0,
  scenerio_baseline_hours_nurse: 0,
  scenerio_baseline_hours_other: 0,
  scenerio_new_hours_physician: 0,
  scenerio_new_hours_nurse: 0,
  scenerio_new_hours_other: 0,
  
  xiaflexPrepTotal: 0,
  xiaflexProcedureDayTotal: 0,
  xiaflexAftercareTotal: 0,
  fasciectomyPrepTotal: 0,
  fasciectomyProcedureDayTotal: 0,
  fasciectomyAftercareTotal: 0,

  xiaflexTimeTotalPerProcedure: 0,
  fasciectomyTimeTotalPerProcedure: 0,

  altProcedureName: "Trigger Finger Release",
};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {

  const [isEdMode, setIsEdMode] = useState(false);

  useEffect(() => {
    const isEdMode = new URLSearchParams(window.location.search).get("ed") === "1";
    setIsEdMode(isEdMode);
    if (isEdMode) {
      document.body.classList.add("ed-mode");
    }

    const isDebug = isDebugMode();
    setIsDebug(isDebug);

    if ("ontouchstart" in document.documentElement) {
      setIsTouchScreen(true);
    } else {
      setIsTouchScreen(false);
    }

    // on screensize change - for when you toggle between touch and non-touch devices in chrome dev tools
    const handleResize = () => {
      if ("ontouchstart" in document.documentElement) {
        setIsTouchScreen(true);
      } else {
        setIsTouchScreen(false);
      }
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const [isTouchScreen, setIsTouchScreen] = useState(false);

  const [isDebug, setIsDebug] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [currentStep, setCurrentStep] = useState(defaultState.currentStep);

  const [showIsiModal, setShowIsiModal] = useState(false);
  const [showPiModal, setShowPiModal] = useState(false);
  const [showMgModal, setShowMgModal] = useState(false);

  useEffect(() => {
    const whichModalOpen = showIsiModal ? "Important Safety Information" : showPiModal ? "Prescribing Information" : null;
    if (whichModalOpen) {
      trackVirtualPageview(whichModalOpen);
    }
  }, [showIsiModal, showPiModal]);

  useEffect(() => {
    // force isi
    if (currentStep === 1) {
      const isiHasSeen = sessionStorage.getItem("ADM_ISI_HasSeen");
      if (!isiHasSeen && !isEdMode) {
        setShowIsiModal(true);
        sessionStorage.setItem("ADM_ISI_HasSeen", "true");
      }
    }

  }, [currentStep, isEdMode]);

  useEffect(() => {
    if (isLoggedIn) {
      trackVirtualPageview(getWorkflowStepName(currentStep));
    }
  }, [currentStep, isLoggedIn]);


  const [showContentModal, setShowContentModal] = useState(defaultState.showContentModal);

  useEffect(() => {
    if (isLoggedIn && typeof window !== 'undefined') {
      const allInputs = document.querySelectorAll("input, textarea, select");
      allInputs.forEach(input => {
        input.addEventListener("blur", () => {
          trackFormInput(input.dataset.label, getWorkflowStepName(currentStep));
        });
      });
    }
  }, [currentStep, showContentModal, isLoggedIn]);

  const [physician_hours_xiaflex, setPhysicianHoursXiaflex] = useState(defaultState.physician_hours_xiaflex);
  const [physician_hours_fasciectomy, setPhysicianHoursFasciectomy] = useState(defaultState.physician_hours_fasciectomy);
  const [nurse_hours_xiaflex, setNurseHoursXiaflex] = useState(defaultState.nurse_hours_xiaflex);
  const [nurse_hours_fasciectomy, setNurseHoursFasciectomy] = useState(defaultState.nurse_hours_fasciectomy);
  const [other_hours_xiaflex, setOtherHoursXiaflex] = useState(defaultState.other_hours_xiaflex);
  const [other_hours_fasciectomy, setOtherHoursFasciectomy] = useState(defaultState.other_hours_fasciectomy);

  const [patient_consultation_xiaflex, setPatientConsultationXiaflex] = useState(defaultState.patient_consultation_xiaflex);
  const [procedure_planning_xiaflex, setProcedurePlanningXiaflex] = useState(defaultState.procedure_planning_xiaflex);
  const [patient_check_in_xiaflex, setPatientCheckInXiaflex] = useState(defaultState.patient_check_in_xiaflex);
  const [room_and_materials_preparation_xiaflex, setRoomAndMaterialsPreparationXiaflex] = useState(defaultState.room_and_materials_preparation_xiaflex);
  const [procedure_xiaflex, setProcedureXiaflex] = useState(defaultState.procedure_xiaflex);
  const [recovery_and_discharge_xiaflex, setRecoveryAndDischargeXiaflex] = useState(defaultState.recovery_and_discharge_xiaflex);
  const [follow_up_visits_xiaflex, setFollowUpVisitsXiaflex] = useState(defaultState.follow_up_visits_xiaflex);
  const [physical_therapy_xiaflex, setPhysicalTherapyXiaflex] = useState(defaultState.physical_therapy_xiaflex);

  const [patient_consultation_fasciectomy, setPatientConsultationFasciectomy] = useState(defaultState.patient_consultation_fasciectomy);
  const [procedure_planning_fasciectomy, setProcedurePlanningFasciectomy] = useState(defaultState.procedure_planning_fasciectomy);
  const [patient_check_in_fasciectomy, setPatientCheckInFasciectomy] = useState(defaultState.patient_check_in_fasciectomy);
  const [room_and_materials_preparation_fasciectomy, setRoomAndMaterialsPreparationFasciectomy] = useState(defaultState.room_and_materials_preparation_fasciectomy);
  const [procedure_fasciectomy, setProcedureFasciectomy] = useState(defaultState.procedure_fasciectomy);
  const [recovery_and_discharge_fasciectomy, setRecoveryAndDischargeFasciectomy] = useState(defaultState.recovery_and_discharge_fasciectomy);
  const [follow_up_visits_fasciectomy, setFollowUpVisitsFasciectomy] = useState(defaultState.follow_up_visits_fasciectomy);
  const [physical_therapy_fasciectomy, setPhysicalTherapyFasciectomy] = useState(defaultState.physical_therapy_fasciectomy);
  
  const [physician_value, setPhysicianValue] = useState(defaultState.physician_value);
  const [nurse_value, setNurseValue] = useState(defaultState.nurse_value);
  const [other_value, setOtherValue] = useState(defaultState.other_value);

  const [physician_alt_hours, setPhysicianAltHours] = useState(defaultState.physician_alt_hours);
  const [nurse_alt_hours, setNurseAltHours] = useState(defaultState.nurse_alt_hours);
  const [other_alt_hours, setOtherAltHours] = useState(defaultState.other_alt_hours);

  const [num_dc_patients, setNumDcPatients] = useState(defaultState.num_dc_patients);
  const [scenerio_baseline_xiaflex, setScenerioBaselineXiaflex] = useState(defaultState.scenerio_baseline_xiaflex);
  const [scenerio_new_xiaflex, setScenerioNewXiaflex] = useState(defaultState.scenerio_new_xiaflex);

  const [scenerio_baseline_hours_physician, setScenerioBaselineHoursPhysician] = useState(defaultState.scenerio_baseline_hours_physician);
  const [scenerio_baseline_hours_nurse, setScenerioBaselineHoursNurse] = useState(defaultState.scenerio_baseline_hours_nurse);
  const [scenerio_baseline_hours_other, setScenerioBaselineHoursOther] = useState(defaultState.scenerio_baseline_hours_other);

  const [scenerio_new_hours_physician, setScenerioNewHoursPhysician] = useState(defaultState.scenerio_new_hours_physician);
  const [scenerio_new_hours_nurse, setScenerioNewHoursNurse] = useState(defaultState.scenerio_new_hours_nurse);
  const [scenerio_new_hours_other, setScenerioNewHoursOther] = useState(defaultState.scenerio_new_hours_other);

  const [xiaflexTimeTotalPerProcedure, setXiaflexTimeTotalPerProcedure] = useState(defaultState.xiaflexTimeTotalPerProcedure);
  const [fasciectomyTimeTotalPerProcedure, setFasciectomyTimeTotalPerProcedure] = useState(defaultState.fasciectomyTimeTotalPerProcedure);

  const [xiaflexPrepTotal, setXiaflexPrepTotal] = useState(defaultState.xiaflexPrepTotal);
  const [xiaflexProcedureDayTotal, setXiaflexProcedureDayTotal] = useState(defaultState.xiaflexProcedureDayTotal);
  const [xiaflexAftercareTotal, setXiaflexAftercareTotal] = useState(defaultState.xiaflexAftercareTotal);

  const [fasciectomyPrepTotal, setFasciectomyPrepTotal] = useState(defaultState.fasciectomyPrepTotal);
  const [fasciectomyProcedureDayTotal, setFasciectomyProcedureDayTotal] = useState(defaultState.fasciectomyProcedureDayTotal);
  const [fasciectomyAftercareTotal, setFasciectomyAftercareTotal] = useState(defaultState.fasciectomyAftercareTotal);

  const [altProcedureName, setAltProcedureName] = useState(defaultState.altProcedureName);

  //time take - calculate total time per procedure
  useEffect(() => {
    const xiaflexPrepTotal = patient_consultation_xiaflex + procedure_planning_xiaflex;
    setXiaflexPrepTotal(xiaflexPrepTotal);
    const xiaflexProcedureDayTotal = patient_check_in_xiaflex + room_and_materials_preparation_xiaflex + procedure_xiaflex + recovery_and_discharge_xiaflex;
    setXiaflexProcedureDayTotal(xiaflexProcedureDayTotal);
    const xiaflexAftercareTotal = follow_up_visits_xiaflex + physical_therapy_xiaflex;
    setXiaflexAftercareTotal(xiaflexAftercareTotal);
    
    const fasciectomyPrepTotal = patient_consultation_fasciectomy + procedure_planning_fasciectomy;
    setFasciectomyPrepTotal(fasciectomyPrepTotal);
    const fasciectomyProcedureDayTotal = patient_check_in_fasciectomy + room_and_materials_preparation_fasciectomy + procedure_fasciectomy + recovery_and_discharge_fasciectomy;
    setFasciectomyProcedureDayTotal(fasciectomyProcedureDayTotal);
    const fasciectomyAftercareTotal = follow_up_visits_fasciectomy + physical_therapy_fasciectomy;
    setFasciectomyAftercareTotal(fasciectomyAftercareTotal);

    // final total
    const xiaflexTimeTotalPerProcedure = 
      patient_consultation_xiaflex + procedure_planning_xiaflex +
      patient_check_in_xiaflex + room_and_materials_preparation_xiaflex +
      procedure_xiaflex + recovery_and_discharge_xiaflex +
      follow_up_visits_xiaflex + physical_therapy_xiaflex;
    setXiaflexTimeTotalPerProcedure(xiaflexTimeTotalPerProcedure);
  const fasciectomyTimeTotalPerProcedure = 
      patient_consultation_fasciectomy + procedure_planning_fasciectomy +
      patient_check_in_fasciectomy + room_and_materials_preparation_fasciectomy +
      procedure_fasciectomy + recovery_and_discharge_fasciectomy +
      follow_up_visits_fasciectomy + physical_therapy_fasciectomy;
    setFasciectomyTimeTotalPerProcedure(fasciectomyTimeTotalPerProcedure);

    console.log("xiaflexTimeTotalPerProcedure", xiaflexTimeTotalPerProcedure);
    console.log("fasciectomyTimeTotalPerProcedure", fasciectomyTimeTotalPerProcedure);

  }, [patient_consultation_xiaflex, procedure_planning_xiaflex, patient_check_in_xiaflex, room_and_materials_preparation_xiaflex, procedure_xiaflex, recovery_and_discharge_xiaflex, follow_up_visits_xiaflex, physical_therapy_xiaflex, patient_consultation_fasciectomy, procedure_planning_fasciectomy, patient_check_in_fasciectomy, room_and_materials_preparation_fasciectomy, procedure_fasciectomy, recovery_and_discharge_fasciectomy, follow_up_visits_fasciectomy, physical_therapy_fasciectomy]);

  // scenerio
  useEffect(() => {

    const physicianHoursXiaflex = 
      patient_consultation_xiaflex / TIME_TAKEN_TASK_DEFAULT.patient_consultation_xiaflex * 18.8 +
      procedure_planning_xiaflex / TIME_TAKEN_TASK_DEFAULT.procedure_planning_xiaflex * 3.2 +
      patient_check_in_xiaflex / TIME_TAKEN_TASK_DEFAULT.patient_check_in_xiaflex * 0 +
      room_and_materials_preparation_xiaflex / TIME_TAKEN_TASK_DEFAULT.room_and_materials_preparation_xiaflex * 2.3 +
      procedure_xiaflex / TIME_TAKEN_TASK_DEFAULT.procedure_xiaflex * 25.7 +
      recovery_and_discharge_xiaflex / TIME_TAKEN_TASK_DEFAULT.recovery_and_discharge_xiaflex * 6.5 +
      follow_up_visits_xiaflex / TIME_TAKEN_TASK_DEFAULT.follow_up_visits_xiaflex * 26 +
      physical_therapy_xiaflex / TIME_TAKEN_TASK_DEFAULT.physical_therapy_xiaflex * 0.1;

      setPhysicianHoursXiaflex(physicianHoursXiaflex);

    const physicianHoursFasciectomy = 
      patient_consultation_fasciectomy / TIME_TAKEN_TASK_DEFAULT.patient_consultation_fasciectomy * 19.4 +
      procedure_planning_fasciectomy / TIME_TAKEN_TASK_DEFAULT.procedure_planning_fasciectomy * 11.2 +
      patient_check_in_fasciectomy / TIME_TAKEN_TASK_DEFAULT.patient_check_in_fasciectomy * 0 +
      room_and_materials_preparation_fasciectomy / TIME_TAKEN_TASK_DEFAULT.room_and_materials_preparation_fasciectomy * 25.6 +
      procedure_fasciectomy / TIME_TAKEN_TASK_DEFAULT.procedure_fasciectomy * 134 +
      recovery_and_discharge_fasciectomy / TIME_TAKEN_TASK_DEFAULT.recovery_and_discharge_fasciectomy * 11.3 +
      follow_up_visits_fasciectomy / TIME_TAKEN_TASK_DEFAULT.follow_up_visits_fasciectomy * 33.8 +
      physical_therapy_fasciectomy / TIME_TAKEN_TASK_DEFAULT.physical_therapy_fasciectomy * 0.8;

    setPhysicianHoursFasciectomy(physicianHoursFasciectomy);

    const nurseHoursXiaflex = 
      patient_consultation_xiaflex / TIME_TAKEN_TASK_DEFAULT.patient_consultation_xiaflex * 8.1 +
      procedure_planning_xiaflex / TIME_TAKEN_TASK_DEFAULT.procedure_planning_xiaflex * 3 +
      patient_check_in_xiaflex / TIME_TAKEN_TASK_DEFAULT.patient_check_in_xiaflex * 8 +
      room_and_materials_preparation_xiaflex / TIME_TAKEN_TASK_DEFAULT.room_and_materials_preparation_xiaflex * 0 +
      procedure_xiaflex / TIME_TAKEN_TASK_DEFAULT.procedure_xiaflex * 0 +
      recovery_and_discharge_xiaflex / TIME_TAKEN_TASK_DEFAULT.recovery_and_discharge_xiaflex * 2.8 +
      follow_up_visits_xiaflex / TIME_TAKEN_TASK_DEFAULT.follow_up_visits_xiaflex * 10 +
      physical_therapy_xiaflex / TIME_TAKEN_TASK_DEFAULT.physical_therapy_xiaflex * 0;

    setNurseHoursXiaflex(nurseHoursXiaflex);

    const nurseHoursFasciectomy = 
      patient_consultation_fasciectomy / TIME_TAKEN_TASK_DEFAULT.patient_consultation_fasciectomy * 11.9 +
      procedure_planning_fasciectomy / TIME_TAKEN_TASK_DEFAULT.procedure_planning_fasciectomy * 16.8 +
      patient_check_in_fasciectomy / TIME_TAKEN_TASK_DEFAULT.patient_check_in_fasciectomy * 0 +
      room_and_materials_preparation_fasciectomy / TIME_TAKEN_TASK_DEFAULT.room_and_materials_preparation_fasciectomy * 46.7 +
      procedure_fasciectomy / TIME_TAKEN_TASK_DEFAULT.procedure_fasciectomy * 195.9 +
      recovery_and_discharge_fasciectomy / TIME_TAKEN_TASK_DEFAULT.recovery_and_discharge_fasciectomy * 46.9 +
      follow_up_visits_fasciectomy / TIME_TAKEN_TASK_DEFAULT.follow_up_visits_fasciectomy * 16.1 +
      physical_therapy_fasciectomy / TIME_TAKEN_TASK_DEFAULT.physical_therapy_fasciectomy * 0;

    setNurseHoursFasciectomy(nurseHoursFasciectomy);

    const otherHoursXiaflex = 
      patient_consultation_xiaflex / TIME_TAKEN_TASK_DEFAULT.patient_consultation_xiaflex * 17.9 +
      procedure_planning_xiaflex / TIME_TAKEN_TASK_DEFAULT.procedure_planning_xiaflex * 17.9 +
      patient_check_in_xiaflex / TIME_TAKEN_TASK_DEFAULT.patient_check_in_xiaflex * 14 +
      room_and_materials_preparation_xiaflex / TIME_TAKEN_TASK_DEFAULT.room_and_materials_preparation_xiaflex * 10.3 +
      procedure_xiaflex / TIME_TAKEN_TASK_DEFAULT.procedure_xiaflex * 7.2 +
      recovery_and_discharge_xiaflex / TIME_TAKEN_TASK_DEFAULT.recovery_and_discharge_xiaflex * 0 +
      follow_up_visits_xiaflex / TIME_TAKEN_TASK_DEFAULT.follow_up_visits_xiaflex * 40.3 +
      physical_therapy_xiaflex / TIME_TAKEN_TASK_DEFAULT.physical_therapy_xiaflex * 31.4;

    setOtherHoursXiaflex(otherHoursXiaflex);

    const otherHoursFasciectomy = 
      patient_consultation_fasciectomy / TIME_TAKEN_TASK_DEFAULT.patient_consultation_fasciectomy * 26.7 +
      procedure_planning_fasciectomy / TIME_TAKEN_TASK_DEFAULT.procedure_planning_fasciectomy * 25.6 +
      patient_check_in_fasciectomy / TIME_TAKEN_TASK_DEFAULT.patient_check_in_fasciectomy * 7.6 +
      room_and_materials_preparation_fasciectomy / TIME_TAKEN_TASK_DEFAULT.room_and_materials_preparation_fasciectomy * 0 +
      procedure_fasciectomy / TIME_TAKEN_TASK_DEFAULT.procedure_fasciectomy * 98 +
      recovery_and_discharge_fasciectomy / TIME_TAKEN_TASK_DEFAULT.recovery_and_discharge_fasciectomy * 9.8 +
      follow_up_visits_fasciectomy / TIME_TAKEN_TASK_DEFAULT.follow_up_visits_fasciectomy * 40 +
      physical_therapy_fasciectomy / TIME_TAKEN_TASK_DEFAULT.physical_therapy_fasciectomy * 256.4;

    setOtherHoursFasciectomy(otherHoursFasciectomy);

    const getBaselineHours = (scenerio, num_dc_patients, hours_xiaflex, hours_fasciectomy) => {
      return (
        scenerio/100 * num_dc_patients * 
        hours_xiaflex + 
        (num_dc_patients - (scenerio/100 * num_dc_patients)) * hours_fasciectomy
      ) / 60;
    }

    // baseline xiaflex percent * physician time xiaflex + (number patients - number of xiaflex patients) * physician time fast / 60
    const baseline_xiaflex_hours_physician = getBaselineHours(scenerio_baseline_xiaflex, num_dc_patients, physician_hours_xiaflex, physician_hours_fasciectomy);
    setScenerioBaselineHoursPhysician(baseline_xiaflex_hours_physician);

    const baseline_xiaflex_hours_nurse = getBaselineHours(scenerio_baseline_xiaflex, num_dc_patients, nurse_hours_xiaflex, nurse_hours_fasciectomy);
    setScenerioBaselineHoursNurse(baseline_xiaflex_hours_nurse);

    const baseline_xiaflex_hours_other = getBaselineHours(scenerio_baseline_xiaflex, num_dc_patients, other_hours_xiaflex, other_hours_fasciectomy);
    setScenerioBaselineHoursOther(baseline_xiaflex_hours_other);
    
    const new_xiaflex_hours_physician = getBaselineHours(scenerio_new_xiaflex, num_dc_patients, physician_hours_xiaflex, physician_hours_fasciectomy);
    setScenerioNewHoursPhysician(new_xiaflex_hours_physician);

    const new_xiaflex_hours_nurse = getBaselineHours(scenerio_new_xiaflex, num_dc_patients, nurse_hours_xiaflex, nurse_hours_fasciectomy);
    setScenerioNewHoursNurse(new_xiaflex_hours_nurse);  
    
    const new_xiaflex_hours_other = getBaselineHours(scenerio_new_xiaflex, num_dc_patients, other_hours_xiaflex, other_hours_fasciectomy);
    setScenerioNewHoursOther(new_xiaflex_hours_other);

  }, [
    scenerio_baseline_xiaflex, scenerio_new_xiaflex, num_dc_patients, 
    xiaflexTimeTotalPerProcedure, fasciectomyTimeTotalPerProcedure,
    patient_consultation_xiaflex, procedure_planning_xiaflex, patient_check_in_xiaflex, room_and_materials_preparation_xiaflex, procedure_xiaflex, recovery_and_discharge_xiaflex, follow_up_visits_xiaflex, physical_therapy_xiaflex, 
    patient_consultation_fasciectomy, procedure_planning_fasciectomy, patient_check_in_fasciectomy, room_and_materials_preparation_fasciectomy, procedure_fasciectomy, recovery_and_discharge_fasciectomy, follow_up_visits_fasciectomy, physical_therapy_fasciectomy
  ]);

  const resetTimeTakenXiaflex = () => {
    setPatientConsultationXiaflex(TIME_TAKEN_TASK_DEFAULT.patient_consultation_xiaflex);
    setProcedurePlanningXiaflex(TIME_TAKEN_TASK_DEFAULT.procedure_planning_xiaflex);
    setPatientCheckInXiaflex(TIME_TAKEN_TASK_DEFAULT.patient_check_in_xiaflex);
    setRoomAndMaterialsPreparationXiaflex(TIME_TAKEN_TASK_DEFAULT.room_and_materials_preparation_xiaflex);
    setProcedureXiaflex(TIME_TAKEN_TASK_DEFAULT.procedure_xiaflex);
    setRecoveryAndDischargeXiaflex(TIME_TAKEN_TASK_DEFAULT.recovery_and_discharge_xiaflex);
    setFollowUpVisitsXiaflex(TIME_TAKEN_TASK_DEFAULT.follow_up_visits_xiaflex);
    setPhysicalTherapyXiaflex(TIME_TAKEN_TASK_DEFAULT.physical_therapy_xiaflex);
  }

  const resetTimeTakenFasciectomy = () => {
    setPatientConsultationFasciectomy(TIME_TAKEN_TASK_DEFAULT.patient_consultation_fasciectomy);
    setProcedurePlanningFasciectomy(TIME_TAKEN_TASK_DEFAULT.procedure_planning_fasciectomy);
    setPatientCheckInFasciectomy(TIME_TAKEN_TASK_DEFAULT.patient_check_in_fasciectomy);
    setRoomAndMaterialsPreparationFasciectomy(TIME_TAKEN_TASK_DEFAULT.room_and_materials_preparation_fasciectomy);
    setProcedureFasciectomy(TIME_TAKEN_TASK_DEFAULT.procedure_fasciectomy);
    setRecoveryAndDischargeFasciectomy(TIME_TAKEN_TASK_DEFAULT.recovery_and_discharge_fasciectomy);
    setFollowUpVisitsFasciectomy(TIME_TAKEN_TASK_DEFAULT.follow_up_visits_fasciectomy);
    setPhysicalTherapyFasciectomy(TIME_TAKEN_TASK_DEFAULT.physical_therapy_fasciectomy);
  }

  const resetAll = () => {
    setScenerioBaselineXiaflex(SCENARIO_DEFAULT.baseline_xiaflex);
    setScenerioNewXiaflex(SCENARIO_DEFAULT.new_xiaflex);
    setNumDcPatients(SCENARIO_DEFAULT.num_dc_patients);

    resetTimeTakenXiaflex();
    resetTimeTakenFasciectomy();
    
    setPhysicianValue(VALUE_OF_TIME_STAFF_DEFAULT.physician);
    setNurseValue(VALUE_OF_TIME_STAFF_DEFAULT.nurse);
    setOtherValue(VALUE_OF_TIME_STAFF_DEFAULT.other);

    setPhysicianAltHours(VALUE_OF_TIME_HOURS_ALT_DEFAULT.physician);
    setNurseAltHours(VALUE_OF_TIME_HOURS_ALT_DEFAULT.nurse);
    setOtherAltHours(VALUE_OF_TIME_HOURS_ALT_DEFAULT.other);
  } 

  const store = {
    isEdMode,
    isDebug,
    isTouchScreen,

    isLoggedIn,
    setIsLoggedIn,

    currentStep,
    setCurrentStep,

    showIsiModal,
    setShowIsiModal,
    showPiModal,
    setShowPiModal,
    showMgModal,
    setShowMgModal,

    showContentModal,
    setShowContentModal,

    physician_hours_xiaflex,
    setPhysicianHoursXiaflex,
    physician_hours_fasciectomy,
    setPhysicianHoursFasciectomy,
    nurse_hours_xiaflex,
    setNurseHoursXiaflex,
    nurse_hours_fasciectomy,
    other_hours_xiaflex,
    setOtherHoursXiaflex,
    other_hours_fasciectomy,
    setOtherHoursFasciectomy,

    patient_consultation_xiaflex,
    setPatientConsultationXiaflex,
    procedure_planning_xiaflex,
    setProcedurePlanningXiaflex,
    patient_check_in_xiaflex,
    setPatientCheckInXiaflex,
    room_and_materials_preparation_xiaflex,
    setRoomAndMaterialsPreparationXiaflex,
    procedure_xiaflex,
    setProcedureXiaflex,
    recovery_and_discharge_xiaflex,
    setRecoveryAndDischargeXiaflex,
    follow_up_visits_xiaflex,
    setFollowUpVisitsXiaflex,
    physical_therapy_xiaflex,
    setPhysicalTherapyXiaflex,

    patient_consultation_fasciectomy,
    setPatientConsultationFasciectomy,
    procedure_planning_fasciectomy,
    setProcedurePlanningFasciectomy,
    patient_check_in_fasciectomy,
    setPatientCheckInFasciectomy,
    room_and_materials_preparation_fasciectomy,
    setRoomAndMaterialsPreparationFasciectomy,
    procedure_fasciectomy,
    setProcedureFasciectomy,
    recovery_and_discharge_fasciectomy,
    setRecoveryAndDischargeFasciectomy,
    follow_up_visits_fasciectomy,
    setFollowUpVisitsFasciectomy,
    physical_therapy_fasciectomy,
    setPhysicalTherapyFasciectomy,

    physician_value,
    setPhysicianValue,
    nurse_value,
    setNurseValue,
    other_value,
    setOtherValue,

    physician_alt_hours,
    setPhysicianAltHours,
    nurse_alt_hours,
    setNurseAltHours,
    other_alt_hours,
    setOtherAltHours,

    num_dc_patients,
    setNumDcPatients,
    scenerio_baseline_xiaflex,
    setScenerioBaselineXiaflex,
    scenerio_new_xiaflex,
    setScenerioNewXiaflex,
    
    scenerio_baseline_hours_physician,
    scenerio_baseline_hours_nurse,
    scenerio_baseline_hours_other,

    scenerio_new_hours_physician,
    scenerio_new_hours_nurse,
    scenerio_new_hours_other,

    xiaflexPrepTotal,
    xiaflexProcedureDayTotal,
    xiaflexAftercareTotal,
    fasciectomyPrepTotal,
    fasciectomyProcedureDayTotal,
    fasciectomyAftercareTotal,
    
    xiaflexTimeTotalPerProcedure,
    fasciectomyTimeTotalPerProcedure,

    resetAll,
    resetTimeTakenXiaflex,
    resetTimeTakenFasciectomy,

    altProcedureName,
    setAltProcedureName,
  };

  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export default AppContext;

export { AppProvider };
